/* Slide out cart (sections/cart-drawer.liquid). Added 2026-10-22.

   Any form posting to /cart/add is sent with fetch and the drawer opens with the fresh cart.
   Safety rules, because this is the path every sale takes:
   - A form whose submit was already handled (the Beretta gift script calls preventDefault)
     is left alone. That script and bought together call ABCartDrawer themselves.
   - If the add itself fails, the form is submitted the old way, so nothing is lost.
   - If the add worked but the drawer cannot refresh, the shopper is sent to /cart. The
     form is never submitted a second time, so nothing is added twice.
   - On the cart page itself adds keep the normal page load, which shows the new cart. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var drawer = document.getElementById('abCartDrawer');
  var overlay = document.querySelector('.ab-drawer-overlay');
  if (!drawer || !overlay || !window.fetch || !window.FormData) return;
  var lastFocus = null;
  var onCartPage = /\/cart\/?$/.test(location.pathname);

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function goCart() { location.href = root + 'cart'; }

  function setBadge(n) {
    document.querySelectorAll('.cart-btn').forEach(function (btn) {
      var b = $('.cart-badge', btn);
      if (n > 0) {
        if (!b) { b = document.createElement('span'); b.className = 'cart-badge'; b.setAttribute('aria-hidden', 'true'); btn.appendChild(b); }
        b.textContent = n;
      } else if (b) {
        b.parentNode.removeChild(b);
      }
    });
  }

  function render() {
    return fetch(root + '?sections=cart-drawer', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('render'); return r.json(); })
      .then(function (json) {
        var tmp = document.createElement('div');
        tmp.innerHTML = json['cart-drawer'] || '';
        var fresh = $('#abCartDrawer', tmp);
        if (!fresh) throw new Error('render');
        $('.ab-drawer-body', drawer).innerHTML = $('.ab-drawer-body', fresh).innerHTML;
        $('#abDrawerTitle', drawer).innerHTML = $('#abDrawerTitle', fresh).innerHTML;
        var n = parseInt(fresh.getAttribute('data-cart-count'), 10) || 0;
        drawer.setAttribute('data-cart-count', n);
        setBadge(n);
      });
  }

  function open() {
    lastFocus = document.activeElement;
    overlay.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { overlay.classList.add('open'); drawer.classList.add('open'); });
    document.documentElement.classList.add('ab-drawer-lock');
    var x = $('.ab-drawer-x', drawer);
    if (x) setTimeout(function () { x.focus(); }, 50);
  }

  function close() {
    overlay.classList.remove('open');
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ab-drawer-lock');
    setTimeout(function () { overlay.hidden = true; }, 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function refreshAndOpen() { return render().then(open); }

  window.ABCartDrawer = { open: open, close: close, refresh: render, refreshAndOpen: refreshAndOpen };

  /* Add to cart from any product form: product page, sticky bar, collection cards. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!/\/cart\/add\/?$/.test(form.getAttribute('action') || '')) return;
    if (e.defaultPrevented || onCartPage || form.hasAttribute('data-no-drawer')) return;
    // Buy Now (return_to=/checkout) keeps the native submit, which goes straight to checkout
    if (e.submitter && e.submitter.name === 'return_to') return;
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    var added = false;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form), credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('add'); added = true; return render(); })
      .then(function () { if (btn) btn.disabled = false; open(); })
      .catch(function () {
        if (btn) btn.disabled = false;
        if (added) goCart(); else HTMLFormElement.prototype.submit.call(form);
      });
  });

  /* Header cart icon opens the drawer instead of leaving the page. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.cart-btn');
    if (!link || onCartPage || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    refreshAndOpen().catch(function () { location.href = link.href; });
  });

  /* Inside the drawer: close, quantity, remove, the suggested add. */
  function busy(on) { drawer.classList.toggle('is-busy', on); }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    if (t.closest('[data-drawer-close]')) { e.preventDefault(); close(); return; }
    var q = t.closest('[data-qty-change]');
    if (q && drawer.contains(q)) {
      e.preventDefault(); busy(true);
      fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ id: q.getAttribute('data-key'), quantity: Math.max(0, parseInt(q.getAttribute('data-qty'), 10) || 0) }) })
        .then(function (r) { if (!r.ok) throw new Error('change'); return render(); })
        .catch(goCart)
        .then(function () { busy(false); });
      return;
    }
    var u = t.closest('[data-upsell-add]');
    if (u && drawer.contains(u)) {
      e.preventDefault(); busy(true);
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: parseInt(u.getAttribute('data-upsell-add'), 10), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return render(); })
        .catch(goCart)
        .then(function () { busy(false); });
    }
  });

  /* Escape closes; Tab stays inside the open drawer. */
  document.addEventListener('keydown', function (e) {
    if (!drawer.classList.contains('open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
})();
